import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../toAbsoluteUrl";
import { callApi } from "../API";
import { removeFromCompany } from "../allFunctions";
import { useParams, useLocation } from "react-router-dom";
import BreadcrumbsComponent from "../Components/Breadcrumbs.jsx";
import { useNavigate } from "react-router-dom";

export default function EmployeeDetails() {
  // const location = useLocation();
  // const { userData } = location.state
  // console.log('userData',userData);
  const navigate = useNavigate();

  const { userId } = useParams();
  

  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [breadCrump, setBreadCrump] = useState([
    { name: "Home", link: "/" },
    { name: "My Team", link: "businessDashboard/myteam" },
  ]);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  function getEmployeeDetails() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "employeeProfileData",
      userId: userId,
      // parent:'2974'
    })
      .then((data) => {
        setData(data);
        setBreadCrump([
          ...breadCrump,
          { name: data.fname + data.lname, link: "businessDashboard/myteam" },
        ]);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    getEmployeeDetails();
  }, []);

  return (
    <div className="container">
      <BreadcrumbsComponent pages={breadCrump} />
      <div className="employee-details col-lg-9 col-12 ">
        <div className="head-employee-details align-items-center d-flex gap-12 mb-3">
          <img
            src={toAbsoluteUrl("/media/images/eid-image.svg")}
            alt="badge-icon"
            className="notDark"
          />
           <img
            src={toAbsoluteUrl("/media/images/eid-image-dark.svg")}
            alt="badge-icon"
            className="darkMode"
          />
          <h2>
         { data.fullName ? (data.fullName) : (data.fname + data.lname)}
          </h2>
        </div>
        <div className="employee-details-info">
          <div className="divider" />
          <div className="employee-details-card">
            <div className="align-items-center d-flex gap-12 ">
              <img
                src={toAbsoluteUrl("/media/images/user.svg")}
                alt="badge-icon"
                className="notDark"
              />
              <img
                src={toAbsoluteUrl("/media/images/user-dark.svg")}
                alt="badge-icon"
                className="darkMode"
              />
              <h3>Basic Information</h3>
            </div>
            <div className="divider" />
            <div className="employee-basic-info">
              <div className="employee-info col-md-6 col-12 ">
                <span>Username</span>
                { data.fullName ?
                (<p>{data.fullName}</p>) :
                data.fname  && data.lname ? (
                  <p>{data.fname} { data.lname}</p>
                ) : (
                  <p>-</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Work Email</span>
                {data.userEmail == null || data.userEmail == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.userEmail}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>First Name</span>
                {data.fname == null || data.fname == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.fname}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Last Name</span>
                {data.lname == null || data.lname == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.lname}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Phone Number</span>
                {data.phone == null || data.phone == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.phone}</p>
                )}
              </div>
            </div>
          </div>
          <div className="employee-details-card">
            <div className="align-items-center d-flex gap-12 ">
            <img
            src={toAbsoluteUrl("/media/images/eid-image.svg")}
            alt="badge-icon"
            className="notDark"
          />
           <img
            src={toAbsoluteUrl("/media/images/eid-image-dark.svg")}
            alt="badge-icon"
            className="darkMode"
          />
              <h3>EID Information</h3>
            </div>
            <div className="divider" />
            <div className="employee-basic-info">
              <div className="employee-info col-md-6 col-12 ">
                <span>Full Name (English)</span>
                {data.fullName == null || data.fullName == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.fullName}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Full Name (Arabic)</span>
                {data.fullNameAr == null || data.fullNameAr == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.fullNameAr}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>ID Number</span>
                {/* <p>123456789</p> */}
                {data.emiratesID == null || data.emiratesID == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.emiratesID}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Nationality</span>
                {data.country == null || data.country == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.country}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Sex</span>
                {data.gender == null || data.gender == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.gender}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Occupation</span>
                {data.occupation == null || data.occupation == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.occupation}</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>EID Front Image</span>
                {/* {data.gender == null || data.gender ==""? <p>-</p> : <p>{data.gender}</p>} */}
                {/* file-text.svg */}

                {data.idImageWithoutURL?.length > 0 ? (
                  <div className="view-eid-image">
                    <div className="file-name">
                      <img
                        src={toAbsoluteUrl("/media/images/file-text.svg")}
                        alt="badge-icon"
                      />
                      <p>{data.idImageWithoutURL[1]}</p>
                    </div>
                    <a target="blank" href={data.idImage[1]}>View Attachment</a>
                  </div>
                ) : (
                  <p>-</p>
                )}
              </div>

              <div className="employee-info col-md-6 col-12 ">
                <span>EID Back Image</span>
                {data.idImageWithoutURL?.length > 0 ? (
                  <div className="view-eid-image">
                    <div className="file-name">
                      <img
                        src={toAbsoluteUrl("/media/images/file-text.svg")}
                        alt="badge-icon"
                      />
                      <p>{data.idImageWithoutURL[0]}</p>
                    </div>
                    <a target="blank" href={data.idImage[0]}>View Attachment</a>
                  </div>
                ) : (
                  <p>-</p>
                )}
              </div>
              <div className="employee-info col-md-6 col-12 ">
                <span>Employer</span>
                {data.companyName == null || data.companyName == "" ? (
                  <p>-</p>
                ) : (
                  <p>{data.companyName}</p>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
          <div className="remove-from-company" onClick={ async()=> {
            let removed = ''
          removed =  await removeFromCompany(userId,1)
          console.log('removed',removed);
            if (removed) {
              navigate("/businessDashboard/myTeam");
            }
          }}
          >
        <img
        className="notDark"
                        src={toAbsoluteUrl("/media/images/trash-2.svg")}
                        alt="trash-icon"
                      />
                      <img
                      className="darkMode"
                        src={toAbsoluteUrl("/media/images/trash-2-dark.svg")}
                        alt="trash-icon"
                      />
                      <p>Remove Employee</p>

        </div>
        </div>
        </div>
      
        {/* {loading == 0 ? (
          <div className="display-flex-with-center justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        ) : (
          <>
          </>
        )} */}
      </div>
    </div>
  );
}
